import React from 'react';
import ReactDOM from 'react-dom/client';
import { RecoilRoot } from 'recoil';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../src/Services/Firebase/Firebase'
import { HelmetProvider } from "react-helmet-async";
import { WebSocketProvider } from '../src/context/WebSocketContext.jsx' // i am edited websocket';


function setViewportHeight() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
} 

window.addEventListener('resize', setViewportHeight);
window.addEventListener('load', setViewportHeight);
setViewportHeight();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <RecoilRoot>
        <WebSocketProvider>
          <App />
        </WebSocketProvider>
      </RecoilRoot>
    </HelmetProvider>
   </React.StrictMode>
);